export function openInNewTab(openInNewTabUrl: string) {
    window.open(openInNewTabUrl, '_blank');
}
